module.exports = __webpack_public_path__ + "static/media/VPM_laptop_1.e1b2e1d1.jpg";